export const environment = {
 production: false,
  //api:'http://localhost/acs_soav3_ccc-soav3/rest_api/api'
  api:'https://cccsoav3.mybizpad.com/rest_api/api'
};